import { render, staticRenderFns } from "./trainVideoSort.vue?vue&type=template&id=b8137c54&scoped=true"
import script from "./trainVideoSort.vue?vue&type=script&lang=js"
export * from "./trainVideoSort.vue?vue&type=script&lang=js"
import style0 from "./trainVideoSort.vue?vue&type=style&index=0&id=b8137c54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8137c54",
  null
  
)

export default component.exports